module.exports = __webpack_public_path__ + "img/freefooter-cn.c992b026.png";